import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Pagination } from 'src/app/infraestructure/interfaces/pagination/pagination.DTO';
import { PaginationI } from 'src/app/infraestructure/models/pagination.interface';

const FILTER_PAG_REGEX = /[^1-9]/g;

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Output() setPagination = new EventEmitter<Pagination>();

  @Input() set data(pagination: PaginationI) {
    this.pagination.itemsPage = pagination.itemsPage;
    this.pagination.page = pagination.page;
    this.pagination.pages = pagination.pages;
  }

  pagination = {} as PaginationI;

  itemsPage: number[] = [5, 10, 15, 20]

  pageValidity: number = 1;

  constructor() { }

  ngOnInit(): void {
  }

  selectPage(page?: string) {
    if (page) this.pagination.page = parseInt(page, 10) || 1;

    if ((this.pagination.page === this.pageValidity) || (this.pagination.page > this.pagination.pages)) return;

    const pagination: Pagination = {
      itemsPorPagina: this.pagination.itemsPage,
      numeroPagina: this.pagination.page
    }

    this.setPagination.emit(pagination);

    this.pageValidity = this.pagination.page;
  }

  selectItems() {
    // if(this.pagination.page > this.pagination.pages) return;

    const pagination: Pagination = {
      itemsPorPagina: this.pagination.itemsPage,
      numeroPagina: this.pagination.page
    }

    this.setPagination.emit(pagination);

    this.pageValidity = this.pagination.page;
  }

  formatInput(input: HTMLInputElement) {
    input.value = input.value.replace(FILTER_PAG_REGEX, '');
  }

}
